module.exports = __webpack_public_path__ + "media/images/river/shirt-carousel/shirt-10-326716a06bc4dd04e00f36860dd7ff36.jpg";